import { FC } from "react";

import { AutoActionButton } from "./AutoActionButton";

import { PillBanner } from "components/footer/PillBanner";
import { PillBannerButton } from "components/footer/PillBannerButton";
import { t } from "i18n/i18n";
import { useIsLgOrLarger } from "mds/hooks/use-responsive";

interface ResumePresentationBannerProps {
  onDismiss: () => void;
  onResume: () => void;
}

export const ResumePresentationBanner: FC<ResumePresentationBannerProps> = ({
  onDismiss,
  onResume,
}) => {
  const showShortText = !useIsLgOrLarger();

  return (
    <PillBanner
      buttonChildren={
        <div className="flex items-center gap-1">
          <PillBannerButton
            className="border border-green"
            eventName="Presentation - Dismiss Auto-Resume"
            kind="green"
            onClick={onDismiss}
          >
            {t("common.dismiss")}
          </PillBannerButton>
          <AutoActionButton eventName="Presentation - Resume" onClick={onResume}>
            {t(
              showShortText
                ? "presentation.resume_presentation_short"
                : "presentation.resume_presentation",
            )}
          </AutoActionButton>
        </div>
      }
      kind="green"
      textChildren={t("presentation.continue_where_you_left_off")}
    />
  );
};
